import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import db from "../firebase";
import LiveCommentContent from "./CommentContent";
import { useEffect, useReducer} from "react";
import { actionConsts, reducer } from "../newComponents/StateManager";
import { format } from "date-fns";



const Comments = () => {
    const [state,dispatch]=useReducer(reducer,{comments: []});
  
    useEffect(()=>{
        const date = format(new Date(), "yyyy-MM-dd");
        const collectionref = collection(db,"liveComments");
        const q = query(collectionref,where("date","==",date), orderBy('timestamp','asc'));
        const unsub = onSnapshot(q, (snapshot)=>{
            const items = [];
            snapshot.forEach((doc)=>{
                items.push(doc.data());
            });
            dispatch({type: actionConsts.COMMENTS, payload: items});
        });
        return unsub;
    },[]);

    

    return ( 
    <div className="livevideocomments">
        {state.comments && state.comments.map(data => (
              <LiveCommentContent
              key={data.timestamp}
              userName={data.userName}
              message={data.message}
              emoji={data.emoji}
              
              />
        ))}
    </div> 
    );
}
export default Comments;